import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { QuoteProvider } from "@/context/QuoteContext";
import Header from "@/components/Header";
import Catalog from "@/pages/Catalog";
import Quote from "@/pages/Quote";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import CollabLogin from "@/pages/CollabLogin";
import CollabRegister from "@/pages/CollabRegister";
import CollabDashboard from "@/pages/CollabDashboard";
import Landing from "@/pages/Landing";
import { GuidesList, GuideDetail } from "@/pages/Guides";
import CityLanding from "@/pages/CityLanding";
import ServiceLocation from "@/pages/ServiceLocation";
import cities from "@/data/cities.data.json";

const AdminGate = () => {
  const { isAdmin, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-zinc-500 text-sm">
        Caricamento...
      </div>
    );
  return isAdmin ? <Admin /> : <AdminLogin />;
};

const CollabGate = () => {
  const { isCollab, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-zinc-500 text-sm">
        Caricamento...
      </div>
    );
  return isCollab ? <CollabDashboard /> : <CollabLogin />;
};

function AppShell() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/catalogo" element={<Catalog />} />
          <Route path="/guide" element={<GuidesList />} />
          <Route path="/guide/:slug" element={<GuideDetail />} />
          <Route path="/preventivo" element={<Quote />} />
          <Route path="/servizi/:slug" element={<ServiceLocation />} />
          {cities.map((c) => (
            <Route key={c.slug} path={`/${c.slug}`} element={<CityLanding />} />
          ))}
          <Route path="/admin" element={<AdminGate />} />
          <Route path="/collaboratori/registrati" element={<CollabRegister />} />
          <Route path="/collaboratori" element={<CollabGate />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <footer className="border-t border-zinc-900 py-6 mt-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-2 text-[10px] font-mono uppercase tracking-widest text-zinc-600">
          <div>
            <span className="text-zinc-400">SPECTRUM</span>
            <span className="text-rose-500">.</span> — We{" "}
            <span className="text-rose-500">light</span> up your events
          </div>
          <div>© {new Date().getFullYear()} · Service Audio Video Luci</div>
        </div>
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <QuoteProvider>
          <AppShell />
          <Toaster
            theme="dark"
            position="top-center"
            richColors
            toastOptions={{
              style: {
                background: "#18181B",
                border: "1px solid #27272A",
                color: "#FAFAFA",
              },
            }}
          />
        </QuoteProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
